import Vue from "vue"
import VueRouter from "vue-router"

// 注册Vue Router插件
Vue.use(VueRouter)

const routes = [
  {
    path: "/basic",
    name: "BasicView",
    component: () => import("../views/BasicView.vue"),
    meta: { title: "基本信息" },
  },
  {
    path: "/wenzhen",
    name: "WenzhenView",
    component: () => import("../views/WenzhenView.vue"),
    meta: { title: "问诊" },
  },
  {
    path: "/face",
    name: "FaceView",
    component: () => import("../views/FaceView.vue"),
    meta: { title: "面诊" },
  },
  {
    path: "/tongue",
    name: "TongueView",
    component: () => import("../views/TongueView.vue"),
    meta: { title: "舌诊" },
  },
  {
    path: "/voice",
    name: "VoiceView",
    component: () => import("../views/VoiceView.vue"),
    meta: { title: "闻诊" },
  },
  {
    path: "/pulse",
    name: "PulseView",
    component: () => import("../views/PulseView.vue"),
    meta: { title: "脉诊" },
  },
  {
    path: "/userinfo",
    name: "UserView",
    component: () => import("../views/UserView.vue"),
    meta: { title: "个人信息综合" },
  },
]

// 路由实例
const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
})

export default router
